// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Referal_screenWrappeer__XaOkX {
    max-width: 350px;  
    justify-content: center;
    display: flex;
    margin:0 auto;
}

.Referal_container__b6uja {
    padding-top: 70px;
    text-align: left;
    width: 90%;
    /* max-width: 350px; */
} 

.Referal_titleWrapper__LfbNQ {
    display: flex;
    justify-content: left;
    gap:10px;
    align-items: center;
    margin-bottom: 20px;
}

.Referal_titleText__X90FO {
    font-size: 25px;
    font-weight: bold;
}

.Referal_i__tdX09 {
    width: 18px;
    background-color: white;
    border-radius: 50%;
}

.Referal_subtitleText__7Nk4B {
    margin-bottom: 20px;
}

.Referal_greyWrapper__9CxQn {
    display: flex;
    background-color: #848484;
    padding: 10px;
    border-radius: 5px;
    color: #161616;
    margin-bottom: 40px;
    align-items: center;
    gap: 10px;
}

.Referal_imgPresent__dYumT {
    width: 35px;
    height: 35px;
}

.Referal_boldText__E3V13 {
    font-weight: bold;
}


.Referal_btnAddFriend__hoV-m {
    display: flex; 
    align-items: center; 
    gap: 8px; 
    background-color: #ffc843; 
    border: 2px solid #FFF; 
    border-radius: 5px; 
    padding: 10px 20px; 
    font-size: 16px; 
    font-weight: bold;
    color: #1f1f1f; 
    cursor: pointer; 
    transition: all 0.3s ease;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;
}

.Referal_iconBtnAddFriend__1AHNv {
    width: 25px;
    height: 25px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
}`, "",{"version":3,"sources":["webpack://./src/Components/Referal/Referal.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":[".screenWrappeer {\n    max-width: 350px;  \n    justify-content: center;\n    display: flex;\n    margin:0 auto;\n}\n\n.container {\n    padding-top: 70px;\n    text-align: left;\n    width: 90%;\n    /* max-width: 350px; */\n} \n\n.titleWrapper {\n    display: flex;\n    justify-content: left;\n    gap:10px;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.titleText {\n    font-size: 25px;\n    font-weight: bold;\n}\n\n.i {\n    width: 18px;\n    background-color: white;\n    border-radius: 50%;\n}\n\n.subtitleText {\n    margin-bottom: 20px;\n}\n\n.greyWrapper {\n    display: flex;\n    background-color: #848484;\n    padding: 10px;\n    border-radius: 5px;\n    color: #161616;\n    margin-bottom: 40px;\n    align-items: center;\n    gap: 10px;\n}\n\n.imgPresent {\n    width: 35px;\n    height: 35px;\n}\n\n.boldText {\n    font-weight: bold;\n}\n\n\n.btnAddFriend {\n    display: flex; \n    align-items: center; \n    gap: 8px; \n    background-color: #ffc843; \n    border: 2px solid #FFF; \n    border-radius: 5px; \n    padding: 10px 20px; \n    font-size: 16px; \n    font-weight: bold;\n    color: #1f1f1f; \n    cursor: pointer; \n    transition: all 0.3s ease;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 60px;\n}\n\n.iconBtnAddFriend {\n    width: 25px;\n    height: 25px;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screenWrappeer": `Referal_screenWrappeer__XaOkX`,
	"container": `Referal_container__b6uja`,
	"titleWrapper": `Referal_titleWrapper__LfbNQ`,
	"titleText": `Referal_titleText__X90FO`,
	"i": `Referal_i__tdX09`,
	"subtitleText": `Referal_subtitleText__7Nk4B`,
	"greyWrapper": `Referal_greyWrapper__9CxQn`,
	"imgPresent": `Referal_imgPresent__dYumT`,
	"boldText": `Referal_boldText__E3V13`,
	"btnAddFriend": `Referal_btnAddFriend__hoV-m`,
	"iconBtnAddFriend": `Referal_iconBtnAddFriend__1AHNv`
};
export default ___CSS_LOADER_EXPORT___;
